<template>
  <Card class="menu-card">
    <el-menu slot="title" :default-active="activeIndex" mode="horizontal" @select="handleSelect">
      <!-- <el-menu-item index="0">正式服务器微信菜单配置</el-menu-item>
      <el-menu-item index="1">微信菜单配置</el-menu-item>
      <el-menu-item index="2">名医推荐管理</el-menu-item>
      <el-menu-item index="3">关于我们管理</el-menu-item>
      <el-menu-item index="4">轮播图片管理</el-menu-item> -->
      <el-menu-item index="0">公众号菜单配置</el-menu-item>
      <el-menu-item index="1">公众号关键词回复</el-menu-item>
      <el-menu-item index="2">公众号欢迎语设置</el-menu-item>
    </el-menu>
    <div slot="content">
      <!-- <MenuOnline v-if="menuIndex == 0" />
      <Menu v-if="menuIndex == 1" />
      <GoodDoctor v-if="menuIndex == 2" />
      <AboutUs v-if="menuIndex == 3" /> -->
      <MenuOnline v-if="menuIndex == 0" />
      <KeywordReply v-if="menuIndex == 1" />
      <welcomeMessage v-if="menuIndex == 2" />
    </div>
  </Card>
</template>

<script lang="js">
import Menu from "./Menu.vue"; // 菜单管理
import MenuOnline from "./MenuOnline.vue"; // 菜单管理
import GoodDoctor from "./GoodDoctor.vue"; // 名医管理
import AboutUs from "./AboutUs.vue"; // 关于我们
import KeywordReply from './KeywordReply' //关键词回复
import welcomeMessage from './welcomeMessage.vue' 
export default {
  name: "Scheduling",
  components: { GoodDoctor, Menu, MenuOnline , AboutUs,KeywordReply,welcomeMessage },
  data() {
    return {
      activeIndex: "1", // 默认激活菜单
      menuIndex: "1", // 菜单索引
    }
  },
  created() {
    let index = this.$session.get('wechatIndex')
    if (index) this.activeIndex = this.menuIndex = index;
  },
  mounted() {
    this.judge();
  },
  methods:{
    // 判断是否是名医推荐组件
    judge() {
      let box = document.querySelector('.menu-card').querySelector('.el-card__body');
      if (this.menuIndex == '2') {
        box.classList.add("overflow");
        this.$forceUpdate();
      } else {
        box.classList.remove("overflow");
        this.$forceUpdate();
      }
    },
    // 切换当前显示组件
    handleSelect(key) {
      this.menuIndex = key;
      this.$session.set('wechatIndex', key);
      this.judge();
    }
  }
};
</script>
<style>
.overflow {
  overflow-y: scroll;
}
</style>